
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class StandardButton extends Vue {
  @Prop({
    default: false
  })
  loading!: boolean;
  @Prop({
    default: false
  })
  active!: boolean;
  @Prop({
    default: "auto"
  })
  minWidth!: number | "auto";

  @Prop()
  testId!: string;

  get classList() {
    return {
      "breakdance-toolbar-button": true,
      "breakdance-toolbar-button--active": this.active
    };
  }
}
